export default __webpack_public_path__ + "static/media/circlemail.89b6e7dd.svg";